// @ts-check
import { vitalKeyTypesForComparison } from '../vital-types'
import {
  optionSelectCombinedAutoAndManualCheckpointsWithinCaseTime,
  optionSelectManualVitalsCheckpointsOnCaseDay,
} from './manual-vitals'

export const BASIC_VITALS_IDS = ['sbp', 'dbp', 'spo2', 'rr', 'hr']

/**
 * @param {Checkpoint} checkpoint
 * @param {string[]} keysToInclude
 * @param {NumericVitalValues} aggregator
 */
export const extractNumericValues = (checkpoint, keysToInclude, aggregator) => {
  const { vitalsInUse, values } = checkpoint
  vitalsInUse.forEach(({ id }) => {
    if (keysToInclude.includes(id)) {
      const val = values[id] && values[id].value
      if (typeof val === 'number' && !isNaN(val)) {
        if (!aggregator.hasOwnProperty(id)) {
          aggregator[id] = val
        }
      }
    }
  })
}

const getNumericVitalsFn = (last = false) =>
  /**
   * @param {CaseData} caseData
   * @param {Pick<
   *   ReportRenderingInputs,
   *   'appTime' | 'tempUnit' | 'maxDuration'
   * >} opts
   * @returns {NumericVitalValues}
   */
  (caseData, { appTime, tempUnit, maxDuration }) => {
    const checkpoints = optionSelectCombinedAutoAndManualCheckpointsWithinCaseTime(
      caseData,
      { appTime, tempUnit, maxDuration }
    )
    if (last) {
      checkpoints.reverse()
    }
    /** @type {NumericVitalValues} */
    const result = {}
    // look from the end of the array to the beginning
    for (let i = 0, l = checkpoints.length; i < l; i++) {
      const cp = checkpoints[i]
      extractNumericValues(cp, vitalKeyTypesForComparison, result)
      if (Object.keys(result).length === vitalKeyTypesForComparison.length) {
        return result
      }
    }
    return result
  }
export const optionSelectFirstInCaseVitalsRaw = getNumericVitalsFn(false)
export const optionSelectLastInCaseVitalsRaw = getNumericVitalsFn(true)

/**
 * @param {CaseData} caseData
 * @param {Pick<ReportRenderingInputs, 'appTimeDay' | 'tempUnit'>} opts
 * @returns {NumericVitalValues}
 */
export const optionSelectPreOpInitialManualVital = (
  caseData,
  { appTimeDay, tempUnit }
) => {
  const checkpoints = optionSelectManualVitalsCheckpointsOnCaseDay(caseData, {
    appTimeDay,
    tempUnit,
  })
  if (!checkpoints.length) {
    return null
  }
  /** @type {NumericVitalValues} */
  const result = {}
  extractNumericValues(checkpoints[0], BASIC_VITALS_IDS, result)
  return result
}
